import { ConnectionType } from '@/features/print/constants'
import { SunmiPrinterInfo } from '@/modules/sunmi-printer'
import { FC, ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react'

export type AddPrinterData =
    | {
          connectionType: ConnectionType.Network
          ipAddress: string
      }
    | {
          connectionType: ConnectionType.SunmiDefault
          printerInfo: SunmiPrinterInfo
      }

interface ActionsContextValue {
    setData: (data: AddPrinterData) => void
    unsetData: () => void
}

const Context = createContext<AddPrinterData | undefined>(undefined)

const ActionsContext = createContext<ActionsContextValue>({
    setData: () => {},
    unsetData: () => {},
})

interface AddPrinterProviderProps {
    children: ReactNode
}

const AddPrinterProvider: FC<AddPrinterProviderProps> = ({ children }) => {
    const [data, setDataState] = useState<AddPrinterData | undefined>(undefined)

    const unsetData = useCallback(() => setDataState(undefined), [])

    const actions = useMemo(() => ({ setData: setDataState, unsetData }), [unsetData])

    return (
        <Context.Provider value={data}>
            <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>
        </Context.Provider>
    )
}

export default AddPrinterProvider

export const useAddPrinterData = (): AddPrinterData | undefined => useContext(Context)

export const useAddPrinterActions = (): ActionsContextValue => useContext(ActionsContext)
